
export const PurchaseOrderRouting = [
  {
    path: "/report-center/download/purchase-order/list",
    name: "purchase-order",
    meta: { title: "订单执行表" },
    component: () =>
      import(
        /* webpackChunkName: "labor-wage" */ "@/views/report-center/purchase-order/list/index.vue"
        ),
  },
];
